import { useEffect, useRef, useState } from "react";
import { motion, animate, useReducedMotion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];
export const DUR = { fast: 0.15, base: 0.22, slow: 0.32 };

const listV = { hidden: {}, show: { transition: { staggerChildren: 0.045, delayChildren: 0.02 } } };
const itemV = { hidden: { opacity: 0, y: 8 }, show: { opacity: 1, y: 0, transition: { duration: DUR.base, ease: EASE } } };

export const Stagger = ({ as = "div", className, children, ...rest }) => {
  const C = motion[as];
  return <C variants={listV} initial="hidden" animate="show" className={className} {...rest}>{children}</C>;
};

export const StaggerItem = ({ as = "div", className, children, ...rest }) => {
  const C = motion[as];
  return <C variants={itemV} className={className} {...rest}>{children}</C>;
};

export function CountUp({ value, decimals = 0, duration = 0.9, className, testId, suffix = "", style }) {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [v, setV] = useState(reduce ? value ?? 0 : 0);
  useEffect(() => {
    if (value == null || !inView) return undefined;
    if (reduce) { setV(value); return undefined; }
    const c = animate(0, Number(value), { duration, ease: EASE, onUpdate: setV });
    return () => c.stop();
  }, [value, inView, reduce, duration]);
  return (
    <span ref={ref} className={className} style={style} data-testid={testId}>
      {value == null ? "—" : `${Number(v).toFixed(decimals)}${suffix}`}
    </span>
  );
}
